import React from "react";
import { View, StyleSheet } from "react-native";
import QRCodeSVG from "react-native-qrcode-svg";
import { useTheme } from "@/hooks/useTheme";

export interface QRCodeProps {
  /** The value to encode in the QR code */
  value: string;
  /** Size of the QR code (width and height). Default: 200 */
  size?: number;
  /** Background color. Default: transparent */
  backgroundColor?: string;
  /** Color of the QR code. Default: theme text color */
  color?: string;
  /** Logo to display in the center */
  logo?: { uri: string } | number;
  /** Size of the logo. Default: size * 0.2 */
  logoSize?: number;
  /** Background color behind the logo */
  logoBackgroundColor?: string;
  /** Border radius of the logo background */
  logoBorderRadius?: number;
  /** Margin around the logo */
  logoMargin?: number;
  /** Error correction level: L, M, Q, H. Default: M */
  ecl?: "L" | "M" | "Q" | "H";
  /** Quiet zone (white border) size. Default: 0 */
  quietZone?: number;
}

export function QRCode({
  value,
  size = 200,
  backgroundColor = "transparent",
  color,
  logo,
  logoSize,
  logoBackgroundColor = "white",
  logoBorderRadius = 0,
  logoMargin = 2,
  ecl = "M",
  quietZone = 0,
}: QRCodeProps) {
  const { colors } = useTheme();
  const qrColor = color || colors.text;

  return (
    <View style={styles.container}>
      <QRCodeSVG
        value={value}
        size={size}
        backgroundColor={backgroundColor}
        color={qrColor}
        logo={logo}
        logoSize={logoSize}
        logoBackgroundColor={logoBackgroundColor}
        logoBorderRadius={logoBorderRadius}
        logoMargin={logoMargin}
        ecl={ecl}
        quietZone={quietZone}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    justifyContent: "center",
  },
});

export default QRCode;
